import React from 'react'

// Root context
interface InternalContextValue {
  open: boolean
  x: number | null
  y: number | null
  disabled?: boolean
  openAt: (x: number, y: number) => void
  close: () => void
}

export const ContextMenuCtx = React.createContext<InternalContextValue | null>(null)

export const useContextMenu = () => {
  const ctx = React.useContext(ContextMenuCtx)
  if (!ctx) throw new Error('useContextMenu must be used inside <ContextMenu>')
  return ctx
}
